import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import {
	StyledInput
} from 'lib/styles';

const Container = styled.div`
	padding: 32px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Adjustment = props => {
	const { t, lng, value } = props;

	return (
		<Container>
			<Label>{t('controls/pictogram/value/label')}</Label>
			<StyledInput
				type="text"
				value={value[lng] || ''}
				onChange={event => props.onChange(event.target.value)}
			/>
		</Container>
	)
}

Adjustment.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	value: PropTypes.object,
	onChange: PropTypes.func,
}

export default translate('translations')(Adjustment)
